import { createSelector } from 'reselect';

import { SORT_BY } from './constants';

const archives = (store) => store.apps.archives;

const containerSelector = createSelector([
  archives,
  (store) => store.user,
],
(filteredState, user) => ({
  activeSortMethod: filteredState.query.getIn(['query', 'sort']),
  columns: filteredState.columns,
  filterDate: filteredState.query.get('filterDate'),
  filters: filteredState.query.get('filters'),
  initialized: filteredState.container.get('initialized'),
  inputQuery: filteredState.query.get('inputQuery'),
  isInfiniteScrollDisabled: filteredState.query.get('isInfiniteScrollDisabled'),
  jobsTeamSharingEnabled: user.isOrgAdmin() || user.organization.settings.jobs_cross_team_sharing,
  queryError: filteredState.container.get('queryError'),
  searchLoading: filteredState.container.get('searchLoading'),
  selectedJobs: filteredState.container.get('selectedJobs'),
  siblings: filteredState.container.get('siblings'),
  results: filteredState.query.get('results'),
  savedQueries: filteredState.container.get('savedQueries'),
  sortBy: SORT_BY,
  user,
}));

export default containerSelector;
export {
  containerSelector,
  archives,
};
